export interface TaxIdType {
	country: string;
	code: string; // Not all supported codes are in StripeCheckoutTaxIdType
	description: string;
	example: string;
	impactInTaxCalculation: boolean;
}

export const STRIPE_TAX_ID_TYPES: TaxIdType[] = [
	{
		country: 'Albania',
		code: 'al_tin',
		description: 'Albania Tax Identification Number',
		example: 'J12345678N',
		impactInTaxCalculation: true,
	},
	{
		country: 'Andorra',
		code: 'ad_nrt',
		description: 'Andorran NRT number',
		example: 'A-123456-Z',
		impactInTaxCalculation: false,
	},
	{
		country: 'Angola',
		code: 'ao_tin',
		description: 'Angola Tax Identification Number',
		example: '5123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Argentina',
		code: 'ar_cuit',
		description: 'Argentinian tax ID number',
		example: '12-3456789-01',
		impactInTaxCalculation: false,
	},
	{
		country: 'Armenia',
		code: 'am_tin',
		description: 'Armenia Tax Identification Number',
		example: '02538904',
		impactInTaxCalculation: true,
	},
	{
		country: 'Aruba',
		code: 'aw_tin',
		description: 'Aruba Tax Identification Number',
		example: '12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Australia',
		code: 'au_abn',
		description: 'Australian Business Number (AU ABN)',
		example: '12345678912',
		impactInTaxCalculation: true,
	},
	{
		country: 'Australia',
		code: 'au_arn',
		description: 'Australian Taxation Office Reference Number',
		example: '123456789123',
		impactInTaxCalculation: false,
	},
	{
		country: 'Austria',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'ATU12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Azerbaijan',
		code: 'az_tin',
		description: 'Azerbaijan Tax Identification Number',
		example: '0123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Bahamas',
		code: 'bs_tin',
		description: 'Bahamas Tax Identification Number',
		example: '123.456.789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Bahrain',
		code: 'bh_vat',
		description: 'Bahraini VAT Number',
		example: '123456789012345',
		impactInTaxCalculation: true,
	},
	{
		country: 'Bangladesh',
		code: 'bd_bin',
		description: 'Bangladesh Business Identification Number',
		example: '123456789-0123',
		impactInTaxCalculation: true,
	},
	{
		country: 'Barbados',
		code: 'bb_tin',
		description: 'Barbados Tax Identification Number',
		example: '1123456789012',
		impactInTaxCalculation: false,
	},
	{
		country: 'Belarus',
		code: 'by_tin',
		description: 'Belarus TIN Number',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Belgium',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'BE0123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Benin',
		code: 'bj_ifu',
		description: 'Benin Tax Identification Number (Identifiant Fiscal Unique)',
		example: '1234567890123',
		impactInTaxCalculation: true,
	},
	{
		country: 'Bolivia',
		code: 'bo_tin',
		description: 'Bolivian tax ID',
		example: '123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Bosnia & Herzegovina',
		code: 'ba_tin',
		description: 'Bosnia and Herzegovina Tax Identification Number	',
		example: 'Herzegovina Tax',
		impactInTaxCalculation: true,
	},
	{
		country: 'Brazil',
		code: 'br_cnpj',
		description: 'Brazilian CNPJ number',
		example: '01.234.456/5432-10',
		impactInTaxCalculation: false,
	},
	{
		country: 'Brazil',
		code: 'br_cpf',
		description: 'Brazilian CPF number',
		example: '123.456.789-87',
		impactInTaxCalculation: false,
	},
	{
		country: 'Bulgaria',
		code: 'bg_uic',
		description: 'Bulgaria Unified Identification Code',
		example: '123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Bulgaria',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'BG0123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Burkina Faso',
		code: 'bf_ifu',
		description:
			"Burkina Faso Tax Identification Number (Numéro d'Identifiant Fiscal Unique)	",
		example: '12345678A',
		impactInTaxCalculation: true,
	},
	{
		country: 'Cambodia',
		code: 'kh_tin',
		description: 'Cambodia Tax Identification Number',
		example: '1001-123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Cameroon',
		code: 'cm_niu',
		description:
			"Cameroon Tax Identification Number (Numéro d'Identifiant fiscal Unique)",
		example: 'M123456789000L',
		impactInTaxCalculation: false,
	},
	{
		country: 'Canada',
		code: 'ca_bn',
		description: 'Canadian BN',
		example: '123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Canada',
		code: 'ca_gst_hst',
		description: 'Canadian GST/HST number',
		example: '123456789RT0002',
		impactInTaxCalculation: true,
	},
	{
		country: 'Canada',
		code: 'ca_pst_bc',
		description: 'Canadian PST number (British Columbia)',
		example: 'PST-1234-5678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Canada',
		code: 'ca_pst_mb',
		description: 'Canadian PST number (Manitoba)',
		example: '123456-7',
		impactInTaxCalculation: false,
	},
	{
		country: 'Canada',
		code: 'ca_pst_sk',
		description: 'Canadian PST number (Saskatchewan)',
		example: '1234567',
		impactInTaxCalculation: false,
	},
	{
		country: 'Canada',
		code: 'ca_qst',
		description: 'Canadian QST number (Québec)',
		example: '1234567890TQ1234',
		impactInTaxCalculation: true,
	},
	{
		country: 'Cape Verde',
		code: 'cv_nif',
		description:
			'Cape Verde Tax Identification Number (Número de Identificação Fiscal)',
		example: '213456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Chile',
		code: 'cl_tin',
		description: 'Chilean TIN',
		example: '12.345.678-K',
		impactInTaxCalculation: true,
	},
	{
		country: 'China',
		code: 'cn_tin',
		description: 'Chinese tax ID',
		example: '123456789012345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Colombia',
		code: 'co_nit',
		description: 'Colombian NIT number',
		example: '123.456.789-0',
		impactInTaxCalculation: false,
	},
	{
		country: 'Congo - Kinshasa',
		code: 'cd_nif',
		description:
			'Congo (DR) Tax Identification Number (Número de Identificação Fiscal)',
		example: 'A0123456M',
		impactInTaxCalculation: false,
	},
	{
		country: 'Costa Rica',
		code: 'cr_tin',
		description: 'Costa Rican tax ID',
		example: '1-234-567890',
		impactInTaxCalculation: false,
	},
	{
		country: 'Croatia',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'HR12345678912',
		impactInTaxCalculation: true,
	},
	{
		country: 'Croatia',
		code: 'hr_oib',
		description: 'Croatian Personal Identification Number',
		example: '12345678901',
		impactInTaxCalculation: false,
	},
	{
		country: 'Cyprus',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'CY12345678Z',
		impactInTaxCalculation: true,
	},
	{
		country: 'Czech Republic',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'CZ1234567890',
		impactInTaxCalculation: true,
	},
	{
		country: 'Denmark',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'DK12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Dominican Republic',
		code: 'do_rcn',
		description: 'Dominican RCN number',
		example: '123-4567890-1',
		impactInTaxCalculation: false,
	},
	{
		country: 'Ecuador',
		code: 'ec_ruc',
		description: 'Ecuadorian RUC number',
		example: '1234567890001',
		impactInTaxCalculation: false,
	},
	{
		country: 'Egypt',
		code: 'eg_tin',
		description: 'Egyptian Tax Identification Number',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'El Salvador',
		code: 'sv_nit',
		description: 'El Salvadorian NIT number',
		example: '1234-567890-123-4',
		impactInTaxCalculation: false,
	},
	{
		country: 'Estonia',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'EE123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Ethiopia',
		code: 'et_tin',
		description: 'Ethiopia Tax Identification Number',
		example: '1234567890',
		impactInTaxCalculation: true,
	},
	{
		country: 'EU (European Union)',
		code: 'eu_oss_vat',
		description: 'European One Stop Shop VAT number for non-Union scheme	',
		example: 'Stop Shop VAT number for non',
		impactInTaxCalculation: false,
	},
	{
		country: 'Finland',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'FI12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'France',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'FRAB123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Georgia',
		code: 'ge_vat',
		description: 'Georgian VAT',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Germany',
		code: 'de_stn',
		description: 'German Tax Number (Steuernummer)',
		example: '1234567890',
		impactInTaxCalculation: false,
	},
	{
		country: 'Germany',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'DE123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Greece',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'EL123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Guinea',
		code: 'gn_nif',
		description:
			'Guinea Tax Identification Number (Número de Identificação Fiscal)',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Hong Kong',
		code: 'hk_br',
		description: 'Hong Kong BR number',
		example: '12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Hungary',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'HU12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Hungary',
		code: 'hu_tin',
		description: 'Hungary tax number (adószám)',
		example: '12345678-1-23',
		impactInTaxCalculation: false,
	},
	{
		country: 'Iceland',
		code: 'is_vat',
		description: 'Icelandic VAT',
		example: '123456',
		impactInTaxCalculation: true,
	},
	{
		country: 'India',
		code: 'in_gst',
		description: 'Indian GST number',
		example: '12ABCDE3456FGZH',
		impactInTaxCalculation: true,
	},
	{
		country: 'Indonesia',
		code: 'id_npwp',
		description: 'Indonesian NPWP number',
		example: '012.345.678.9-012.345',
		impactInTaxCalculation: false,
	},
	{
		country: 'Ireland',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'IE1234567AB',
		impactInTaxCalculation: true,
	},
	{
		country: 'Israel',
		code: 'il_vat',
		description: 'Israel VAT',
		example: '000012345',
		impactInTaxCalculation: false,
	},
	{
		country: 'Italy',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'IT12345678912',
		impactInTaxCalculation: true,
	},
	{
		country: 'Japan',
		code: 'jp_cn',
		description: 'Japanese Corporate Number (*Hōjin Bangō*)',
		example: '1234567891234',
		impactInTaxCalculation: false,
	},
	{
		country: 'Japan',
		code: 'jp_rn',
		description:
			'Japanese Registered Foreign Businesses Registration Number (*Tōroku Kokugai Jigyōsha no Tōroku Bangō*)',
		example: '12345',
		impactInTaxCalculation: false,
	},
	{
		country: 'Japan',
		code: 'jp_trn',
		description: 'Japanese Tax Registration Number (*Tōroku Bangō*)',
		example: 'T1234567891234',
		impactInTaxCalculation: true,
	},

	{
		country: 'Kazakhstan',
		code: 'kz_bin',
		description: 'Kazakhstani Business Identification Number',
		example: '123456789012',
		impactInTaxCalculation: true,
	},
	{
		country: 'Kenya',
		code: 'ke_pin',
		description: 'Kenya Revenue Authority Personal Identification Number',
		example: 'P000111111A',
		impactInTaxCalculation: false,
	},
	{
		country: 'Kyrgyzstan',
		code: 'kg_tin',
		description: 'Kyrgyzstan Tax Identification Number',
		example: '12345678901234',
		impactInTaxCalculation: false,
	},
	{
		country: 'Laos',
		code: 'la_tin',
		description: 'Laos Tax Identification Number',
		example: '123456789-000',
		impactInTaxCalculation: false,
	},
	{
		country: 'Latvia',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'LV12345678912',
		impactInTaxCalculation: true,
	},
	{
		country: 'Liechtenstein',
		code: 'li_uid',
		description: 'Liechtensteinian UID number',
		example: 'CHE123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Liechtenstein',
		code: 'li_vat',
		description: 'Liechtenstein VAT number',
		example: '12345',
		impactInTaxCalculation: true,
	},
	{
		country: 'Lithuania',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'LT123456789123',
		impactInTaxCalculation: true,
	},
	{
		country: 'Luxembourg',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'LU12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Malaysia',
		code: 'my_frp',
		description: 'Malaysian FRP number',
		example: '12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Malaysia',
		code: 'my_itn',
		description: 'Malaysian ITN',
		example: 'C 1234567890',
		impactInTaxCalculation: false,
	},
	{
		country: 'Malaysia',
		code: 'my_sst',
		description: 'Malaysian SST number',
		example: 'A12-3456-78912345',
		impactInTaxCalculation: false,
	},
	{
		country: 'Malta',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'MT12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Mauritania',
		code: 'mr_nif',
		description:
			'Mauritania Tax Identification Number (Número de Identificação Fiscal)',
		example: '12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Mexico',
		code: 'mx_rfc',
		description: 'Mexican RFC number',
		example: 'ABC010203AB9',
		impactInTaxCalculation: false,
	},
	{
		country: 'Moldova',
		code: 'md_vat',
		description: 'Moldova VAT Number',
		example: '1234567',
		impactInTaxCalculation: true,
	},
	{
		country: 'Montenegro',
		code: 'me_pib',
		description: 'Montenegro PIB Number',
		example: '12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Morocco',
		code: 'ma_vat',
		description: 'Morocco VAT Number',
		example: '12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Nepal',
		code: 'np_pan',
		description: 'Nepal PAN Number',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Netherlands',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'NL123456789B12',
		impactInTaxCalculation: true,
	},
	{
		country: 'New Zealand',
		code: 'nz_gst',
		description: 'New Zealand GST number',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Nigeria',
		code: 'ng_tin',
		description: 'Nigerian Tax Identification Number',
		example: '12345678-0001',
		impactInTaxCalculation: false,
	},
	{
		country: 'North Macedonia',
		code: 'mk_vat',
		description: 'North Macedonia VAT Number',
		example: 'MK1234567890123',
		impactInTaxCalculation: true,
	},
	{
		country: 'Norway',
		code: 'no_vat',
		description: 'Norwegian VAT number',
		example: '123456789MVA',
		impactInTaxCalculation: true,
	},
	{
		country: 'Norway',
		code: 'no_voec',
		description: 'Norwegian VAT on e-commerce number',
		example: '1234567',
		impactInTaxCalculation: false,
	},
	{
		country: 'Oman',
		code: 'om_vat',
		description: 'Omani VAT Number',
		example: 'OM1234567890',
		impactInTaxCalculation: true,
	},
	{
		country: 'Peru',
		code: 'pe_ruc',
		description: 'Peruvian RUC number',
		example: '12345678901',
		impactInTaxCalculation: true,
	},
	{
		country: 'Philippines',
		code: 'ph_tin',
		description: 'Philippines Tax Identification Number',
		example: '123456789012',
		impactInTaxCalculation: false,
	},
	{
		country: 'Poland',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'PL1234567890',
		impactInTaxCalculation: true,
	},
	{
		country: 'Portugal',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'PT123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Romania',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'RO1234567891',
		impactInTaxCalculation: true,
	},
	{
		country: 'Romania',
		code: 'ro_tin',
		description: 'Romanian tax ID number',
		example: '1234567890123',
		impactInTaxCalculation: false,
	},
	{
		country: 'Russia',
		code: 'ru_inn',
		description: 'Russian INN',
		example: '1234567891',
		impactInTaxCalculation: true,
	},
	{
		country: 'Russia',
		code: 'ru_kpp',
		description: 'Russian KPP',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Saudi Arabia',
		code: 'sa_vat',
		description: 'Saudi Arabia VAT',
		example: '123456789012345',
		impactInTaxCalculation: true,
	},
	{
		country: 'Senegal',
		code: 'sn_ninea',
		description: 'Senegal NINEA Number',
		example: '12345672A2',
		impactInTaxCalculation: false,
	},
	{
		country: 'Serbia',
		code: 'rs_pib',
		description: 'Serbian PIB number',
		example: '123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Singapore',
		code: 'sg_gst',
		description: 'Singaporean GST',
		example: 'M12345678X',
		impactInTaxCalculation: true,
	},
	{
		country: 'Singapore',
		code: 'sg_uen',
		description: 'Singaporean UEN',
		example: '123456789F',
		impactInTaxCalculation: false,
	},
	{
		country: 'Slovakia',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'SK1234567891',
		impactInTaxCalculation: true,
	},
	{
		country: 'Slovenia',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'SI12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Slovenia',
		code: 'si_tin',
		description: 'Slovenia tax number (davčna številka)',
		example: '12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'South Africa',
		code: 'za_vat',
		description: 'South African VAT number',
		example: '4123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'South Korea',
		code: 'kr_brn',
		description: 'Korean BRN',
		example: '123-45-67890',
		impactInTaxCalculation: true,
	},
	{
		country: 'Spain',
		code: 'es_cif',
		description: 'Spanish NIF number (previously Spanish CIF number)',
		example: 'A12345678',
		impactInTaxCalculation: false,
	},
	{
		country: 'Spain',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'ESA1234567Z',
		impactInTaxCalculation: true,
	},
	{
		country: 'Suriname',
		code: 'sr_fin',
		description: 'Suriname FIN Number',
		example: '1234567890',
		impactInTaxCalculation: true,
	},
	{
		country: 'Sweden',
		code: 'eu_vat',
		description: 'European VAT number',
		example: 'SE123456789123',
		impactInTaxCalculation: true,
	},
	{
		country: 'Switzerland',
		code: 'ch_uid',
		description: 'Switzerland UID number',
		example: 'CHE-123.456.789 HR',
		impactInTaxCalculation: false,
	},
	{
		country: 'Switzerland',
		code: 'ch_vat',
		description: 'Switzerland VAT number',
		example: 'CHE-123.456.789 MWST',
		impactInTaxCalculation: true,
	},
	{
		country: 'Taiwan',
		code: 'tw_vat',
		description: 'Taiwanese VAT',
		example: '12345678',
		impactInTaxCalculation: true,
	},
	{
		country: 'Tajikistan',
		code: 'tj_tin',
		description: 'Tajikistan Tax Identification Number',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Tanzania',
		code: 'tz_vat',
		description: 'Tanzania VAT Number',
		example: '12345678A',
		impactInTaxCalculation: true,
	},
	{
		country: 'Thailand',
		code: 'th_vat',
		description: 'Thai VAT',
		example: '1234567891234',
		impactInTaxCalculation: true,
	},
	{
		country: 'Turkey',
		code: 'tr_tin',
		description: 'Turkish Tax Identification Number',
		example: '0123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'Uganda',
		code: 'ug_tin',
		description: 'Uganda Tax Identification Number',
		example: '1014751879',
		impactInTaxCalculation: true,
	},
	{
		country: 'Ukraine',
		code: 'ua_vat',
		description: 'Ukrainian VAT',
		example: '123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'United Arab Emirates',
		code: 'ae_trn',
		description: 'United Arab Emirates TRN',
		example: '123456789012345',
		impactInTaxCalculation: true,
	},
	{
		country: 'United Kingdom',
		code: 'eu_vat',
		description: 'Northern Ireland VAT number',
		example: 'XI123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'United Kingdom',
		code: 'gb_vat',
		description: 'United Kingdom VAT number',
		example: 'GB123456789',
		impactInTaxCalculation: true,
	},
	{
		country: 'United States',
		code: 'us_ein',
		description: 'United States EIN',
		example: '12-3456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Uruguay',
		code: 'uy_ruc',
		description: 'Uruguayan RUC number',
		example: '123456789012',
		impactInTaxCalculation: true,
	},
	{
		country: 'Uzbekistan',
		code: 'uz_tin',
		description: 'Uzbekistan TIN Number',
		example: '123456789',
		impactInTaxCalculation: false,
	},
	{
		country: 'Uzbekistan',
		code: 'uz_vat',
		description: 'Uzbekistan VAT Number',
		example: '123456789012',
		impactInTaxCalculation: true,
	},
	{
		country: 'Venezuela',
		code: 've_rif',
		description: 'Venezuelan RIF number',
		example: 'A-12345678-9',
		impactInTaxCalculation: false,
	},
	{
		country: 'Vietnam',
		code: 'vn_tin',
		description: 'Vietnamese tax ID number',
		example: '1234567890',
		impactInTaxCalculation: false,
	},
	{
		country: 'Zambia',
		code: 'zm_tin',
		description: 'Zambia Tax Identification Number',
		example: '1004751879',
		impactInTaxCalculation: false,
	},
	{
		country: 'Zimbabwe',
		code: 'zw_tin',
		description: 'Zimbabwe Tax Identification Number',
		example: '1234567890',
		impactInTaxCalculation: false,
	},
] as const;
